import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { tap, map, catchError } from 'rxjs/operators';
import { Attachment, AttachmentErrors } from '../models/attachment.model';
import { of, throwError } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { tenMegaByteInByte } from '../utils/const.util';

@Injectable({
    providedIn: 'root'
})
export class AttachmentService {
    private url = environment.url;

    constructor(
        private http: HttpClient,
        private toastr: ToastrService
    ) { }


    uploadAttachment(files: FileList, id) {
        const formData: FormData = new FormData();
        let correctFilesCounter = 0;
        for (let i = 0; i < files.length; i++) {
            if (files[i].size > tenMegaByteInByte) {
                this.handleUploadAttachmentError(AttachmentErrors.FileTooBig, files[i].name);
            } else {
                formData.append('file' + i, files[i], files[i].name);
                correctFilesCounter++;
            }
        }
        formData.append('costId', id);
        if(correctFilesCounter > 0) {
            return this.http.post<Attachment[]>(`${this.url}attachment`, formData).pipe(
                map(v => v.map(Attachment.adapt)),
                catchError(error => {
                    this.handleUploadAttachmentError(error.error.message);
                    return throwError(error);
                }),
            );
        } else {
            return throwError('Upload could not be fully finished.');
        }
    }

    private handleUploadAttachmentError(messageCode, fileName?: string) {

        switch (messageCode) {
            case AttachmentErrors.FileTooBig:
                const errorMessage = fileName
                    ? `Plik ${fileName} przekroczył maksymalny rozmiar 10 MB`
                    : 'Maksymalny rozmiar pliku to 10 MB';

                this.toastr.error(errorMessage);
                break;
        }

    }

    downloadAttachment(id) {
        return this.http.get(`${this.url}attachment/${id}`, { responseType: 'blob' }).pipe(
        );
    }

    removeAttachment(id) {
        return this.http.delete(`${this.url}attachment/` + id).pipe(
        );
    }
}
